import Container from "react-bootstrap/Container";
import { Card, Form, Row, Col } from "react-bootstrap";
import logo from "../images/logo.webp";
import DateRangeComp from "./DateRangeComp";
import Button from "react-bootstrap/Button";
import React, { useState } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import Slider from "react-slick";
import LeadsByMonthGraph from "../Grpahs/LeadsByMonthGraph";

// db imports
// import db from "../database/db.json";
// import db1 from "../database/db1.json";
// import YearToDateVisualGraph from "../Grpahs/YearToDateVisualGraph";
import LeadVolume from '../database/LeadVolume.json';
 import LeadsByMonth from '../database/LeadsByMonth.json';
 import YearToDateVisual from '../database/Year-To-Date-Visual.json';
import RadialBarChart from "../Grpahs/RadialBarChart";
import StudentDropoutsByBranch from '../database/StudentDropoutsByBranch.json'
import Treemap from "../Grpahs/Treemap";
import StudentDropoutsByMonth from '../database/StudentDropoutsByMonth.json'
import Header from "./Header";

export const StudentDropouts= () => {
 


  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1
  };

  return (
    <React.Fragment>
    <Header/>
      <Container fluid style={{height:'80%'}}>
        <Row>
          <Col>
            <Container fluid>
              <Row>
                <Col xs={6} style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={logo}
                    className="d-inline-block align-top"
                    alt="logo"
                  />
                  <h2 style={{ fontSize: "50px" }}>
                    <strong>&nbsp;Student Dropouts</strong>
                  </h2>
                </Col>
                
                <Col
                  xs={3}
                  
                  
                >
                  <Card
                    className="text-center"
                    style={{
                      
                      boxShadow: "2px 2px 8px ",
                      
                       height: "100px",
                       width: "210px",
                       marginTop: '3px',
                       marginLeft: "52px",
                       position:'initial'
                  
                    }}
                  >
                    <Card.Header
                      style={{ backgroundColor: "black", color: "white" }}
                    >
                      Total Leads Generated
                    </Card.Header>
                    <Card.Body
                      style={{ paddingTop: "6px", textAlign: "center" }}
                    >
                      <h1>17</h1>
                    </Card.Body>
                  </Card>
                  </Col>
                  
                  <Col xs={3}>
                  <Card
                    className="text-center"
                    style={{
                      height: "100px",
                      width: "210px",
                      boxShadow: "2px 2px 8px ",
                      marginTop:'3px',
                      // position:'initial'
                    }}
                  >
                    <Card.Header
                      style={{ color: "white", backgroundColor: "black" }}
                    >
                      Date Range
                    </Card.Header>
                    <Card.Body style={{ paddingTop: "1px" }}>
                      
                  <DateRangeComp/>




                    </Card.Body>
                    </Card>
                  </Col>
                
              </Row>
            </Container>
          </Col>
        </Row>
        <Row>
          <Col>
            <hr
              style={{
                height: "4px",
                borderWidth: "0",
                color: "black",
                backgroundColor: "black",
                marginTop: "7px",
                marginBottom: "5px",
                position:'initial'
              }}
            ></hr>
          </Col>
        </Row>
        <Row>
          <Col xs={3}>
            <Card style={{ boxShadow: "2px 2px 8px ",position:'initial' }}>
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Month
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>Open this select menu</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={3}>
            <Card style={{ boxShadow: "2px 2px 8px ",position:'initial' }}>
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Branch
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>Open this select menu</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={3}>
            <Card
              style={{
                boxShadow: "2px 2px 8px ",
                paddingTop: "0px",
                paddingBottom: "8px",
                position:'initial'
              }}
            >
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select User
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>Open this select menu</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={3}>
            <Card style={{ boxShadow: "2px 2px 8px ", width: "18rem" ,position:'initial'}}>
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Year
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                
                <Slider {...settings} className='slider' style={{margin:'1px'}}>
                    <div>
                      <Button variant="secondary">2017</Button>
                    </div>
                    <div>
                      <Button variant="secondary">2018</Button>
                    </div>
                    <div>
                      <Button variant="secondary">2019</Button>
                    </div>
                    <div>
                      <Button variant="secondary">2020</Button>
                    </div>
                    <div>
                      <Button variant="secondary">2021</Button>
                    </div>
                    <div>
                      <Button variant="secondary">2022</Button>
                    </div>
                    
                      
                    
                  </Slider>
                
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row style={{marginTop:'5px'}}>
        <Col xs={6}>
        
        <Card style={{height:'412px',boxShadow: "2px 2px 8px ",position:'initial'}}>
        <Card.Title style={{textAlign:'center',textDecoration:'underline'}}>Students Dropouts by Branch</Card.Title>
        
        <Card.Body style={{padding:'8px'}}>
        
        
        <Treemap db={StudentDropoutsByBranch} height='350'/>

        </Card.Body>

        </Card>
        
        </Col>
        <Col xs={6}>
        <Card style={{height:'412px',boxShadow: "2px 2px 8px ",position:'initial'}}>
        
        <Card.Title style={{textAlign:'center',textDecoration:'underline'}}>Students Dropouts By Month</Card.Title>
        <Card.Body style={{padding:'10px'}}>
        
        <LeadsByMonthGraph height='350' color="#F7B844" db={StudentDropoutsByMonth.table1} graphType="bar" />

        
        </Card.Body>
        </Card>
        
        </Col>
        </Row>
        </Container>
        </React.Fragment>
  )
            }



        export default StudentDropouts;